<form novalidate #currentForm="ngForm">
  <div class="form-group">
    <label>Account #</label>
    <input type="text" class="form-control form-control-sm" name="account_number" [(ngModel)]="vendor.account_number" />
  </div>
  <div class="form-group">
    <label>Address</label>
    <select required class="form-control form-control-sm" name="address_id" [(ngModel)]="vendor.address_id">
      <option *ngFor="let address of contactAddresses" [value]="address.id">
        {{ address.address_clipboard }}
      </option>
    </select>
    <div class="invalid-feedback" [ngClass]="{ 'd-block': !vendor.address_id && formSubmitted }">Address is required</div>
  </div>
  <div class="form-group">
    <label>Chart of Account</label>
    <select required class="form-control form-control-sm" name="chart_of_account_id" [(ngModel)]="vendor.chart_of_account_id">
      <option *ngFor="let chartOfAccount of this.formOptions.chart_of_accounts" [value]="chartOfAccount.value">
        {{ chartOfAccount.label }}
      </option>
    </select>
    <div class="invalid-feedback" [ngClass]="{ 'd-block': !vendor.chart_of_account_id && formSubmitted }">Chart of account is required</div>
  </div>
  <div class="form-group">
    <div class="custom-control custom-checkbox" (click)="vendor.is_auto_withdrawal = !vendor.is_auto_withdrawal">
      <input type="checkbox" class="custom-control-input" [checked]="vendor.is_auto_withdrawal" />
      <label class="custom-control-label">Is Auto W/D</label>
    </div>
    <div class="custom-control custom-checkbox" (click)="vendor.is_priority = !vendor.is_priority">
      <input type="checkbox" class="custom-control-input" [checked]="vendor.is_priority" />
      <label class="custom-control-label">Is Priority</label>
    </div>
  </div>
  <div class="form-row">
    <div class="col-6">
      <button type="button" class="btn btn-primary btn-sm btn-block" (click)="save()" [disabled]="formSubmitting">
        Save
        <span *ngIf="formSubmitting">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-outline-secondary btn-sm btn-block" (click)="saved.emit(false)" [disabled]="formSubmitting">Cancel</button>
    </div>
  </div>
</form>
